import {ReactElement} from 'react';
import AurAccordion from './AurAccordion';

type AurAccordionType = typeof AurAccordion;

type AurAccordionGroupProps = {
  title: string;
  titleContent?: ReactElement | ReactElement[];
  children:
    | ReactElement<AurAccordionType>
    | Array<ReactElement<AurAccordionType>>;
  disabled?: boolean;
  fullWidth?: boolean;
  transparent?: boolean;
  className?: string;
};

const AurAccordionGroup = (props: AurAccordionGroupProps) => {
  const classNames = [];
  if (props.className) {
    classNames.push(props.className);
  }
  if (props.fullWidth) {
    classNames.push('full-width');
  }
  if (props.disabled) {
    classNames.push('disabled');
  }
  if (props.transparent) {
    classNames.push('transparent');
  }
  const className = classNames.join(' ');

  return (
    <>
      <div className={`aur-accordion-group ${className}`}>
        <fieldset disabled={props.disabled}>
          <div className="aur-accordion-group-header">
            <div className="aur-accordion-group-title">{props.title}</div>
            <div className="aur-accordion-group-title-content">
              {props.titleContent}
            </div>
          </div>
          <div className="aur-accordion-group-body">{props.children}</div>
        </fieldset>
      </div>
    </>
  );
};

export default AurAccordionGroup;
